import { render } from "./MdCardHeader.vue?vue&type=template&id=50622c0e"
import script from "./MdCardHeader.vue?vue&type=script&lang=js"
export * from "./MdCardHeader.vue?vue&type=script&lang=js"

import "./MdCardHeader.vue?vue&type=style&index=0&id=50622c0e&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__